import React from "react";
import { Modal } from "reactstrap";
import TransferMoneyForm from "./TransferMoneyForm";

const TransferMoneyModal = ({ program, isOpen, setOpen, toggle }) => {
  const props = { btnLabel: "Transfer", program, toggle };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Billing</span>
          <h3 className="modal-2col__title">Transfer Money</h3>
          <p className="modal-2col__description">
            Move available balance from one program to other programs in the
            hierarchy without creating a new invoice. Enter the transfer
            amounts, review the confirmation, and post the transfer when ready.
          </p>
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <TransferMoneyForm {...props} />
      </div>
    </Modal>
  );
};

export default TransferMoneyModal;
